import { styled } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';

export const StyledGridContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})(({ theme, fullWidth }) => ({
  ...(!fullWidth && {
    margin: '0 auto',
    maxWidth: theme.breakpoints.values['container'],
    flexDirection: 'row',
  }),
}));

export const SidebarBox = styled(Box)(({ theme }) => ({
  maxWidth: theme.breakpoints.values['sidebar'],
  width: '100%',
}));

export const ContentWidth = styled('div')({
  width: '100%',
  margin: 'auto',
  position: 'relative',
  '@media print': {
    width: '100%',
    maxWidth: 100000,
  },
});

export const SideGridItem = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'padTop',
})(({ theme, padTop }) => ({
  padding: 0,
  ...(padTop && { paddingTop: theme.spacing(10) }),
}));

export const CenterGridItem = styled(Grid, {
  shouldForwardProp: (prop) => !['selfCenter', 'overflowHidden', 'fullWidth'].includes(prop),
})(({ selfCenter, overflowHidden, fullWidth }) => ({
  padding: 0,
  ...(selfCenter && { margin: '0 auto' }),
  ...(overflowHidden && { overflow: 'hidden' }),
  ...(fullWidth && {
    width: '100%',
    margin: 'auto',
    position: 'relative',
    '@media print': {
      width: '100%',
      maxWidth: 100000,
    },
  }),
}));
